<template>
    <div>


        <!-- team clock -->
        <tq-event-status-bar
                v-if="p_teamStatus_c"
                class="TQ_margin_top_4px"
                :p_uid_s="$options.name"
                :p_quest-event_c="p_questEvent_c"
                :p_game-status_c="p_gameStatus_c"
                :p_quest-body_c="p_questBody_c"
                :p_current-team-id_uid="p_teamStatus_c.ts_teamId_uid"
                :p_system_lang-code_e="p_system_langCode_e"
        />

        <div class="TQ_padding_4px"></div>

        <div class="TQ_height_300px TQ_scrollable">

            <div v-if="teamStatus_new_c" class="TQ_grid_col_auto1fr">

                <!-- team color -->
                <div class="TQ_padding_8px TQ_grid_verticalCenter TQ_align_end">
                    <tq-pick-color :p_system-lang-code_e="p_system_langCode_e"
                                   :pe_change-color_s="(newColor_s) => {this.gameStatusTeam_new_c.gst_color_s = newColor_s}"
                                   class="TQ_inline TQ_margin_2px"
                                   :p_init-color_s="gameStatusTeam_new_c.gst_color_s">
                        <tq-image :src="ass_img_colors_w"
                                  :style="{'background': gameStatusTeam_new_c.gst_color_s}"
                                  class="TQ_box_shadow TQ_borderRadius TQ_width_24px TQ_padding_8px TQ_clickable TQ_verticalAlignMiddle"
                                  :title="ass_strings.twoWords_teamColor[p_system_langCode_e]"/>


                    </tq-pick-color>
                </div>

                <div class="TQ_grid_verticalCenter TQ_align_initial">
                    <!-- passwords -->
                    <div class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle">
                        <div class="TQ_text_bold"> {{ass_strings.twoWords_teamPassword[p_system_langCode_e]}}: </div>
                        <input class="TQ_center TQ_input TQ_width_150px" type="text" :value="gameStatusTeam_new_c.gst_teamPassword_s" readonly>
                    </div>

                    <!-- clues -->
                    <div class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle" v-if="[enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(p_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e)">
                        <div    class="TQ_text_bold" > {{ass_strings.oneWord_hints[p_system_langCode_e]}}:</div>
                        <input  class="TQ_center TQ_input TQ_width_150px" type="number" v-model.number="teamStatus_new_c.ts_cluesLeft_n" />
                    </div>

                    <!-- skips -->
                    <div class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle" v-if="p_questBody_c.qb_metadata_c.qbm_missions_supportSkips_b">
                        <div   class="TQ_text_bold" > {{ass_strings.oneWord_Skips[p_system_langCode_e]}}: </div>
                        <input class="TQ_center TQ_input TQ_width_150px" type="number" v-model.number="teamStatus_new_c.ts_skipsLeft_n" />
                    </div>

                    <!-- bonus points -->
                    <div class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle" v-if="p_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b">
                        <div   class="TQ_text_bold" > {{ass_strings.twoWords_bonusPoints[p_system_langCode_e]}}: </div>
                        <input class="TQ_center TQ_input TQ_width_150px" type="number" 
                            @change="m_validateBonusPoint_f"
                            v-model.number="teamStatus_new_c.ts_bonusPoints_n" />
                    </div>

                    <!-- missionsArrangement -->
                    <div v-if="p_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e === enum_arrangeMissionsType_s.team_choose_oneTime"
                         class="TQ_inline TQ_margin_4px TQ_verticalAlignMiddle ">

                        <div class="TQ_text_bold" > {{ass_strings.oneWord_path[p_system_langCode_e]}}:</div>
                        <tq-dropdown :style-select="true" class="TQ_width_150px TQ_center" :ps_only-mobile-mode_b="true">

                            <div slot="select">
                                {{p_questBody_c.qb_missionsArrangements_ac[gameStatusTeam_new_c.gst_missionsArrangementIndex_n].qbma_name_s}}
                            </div>

                            <div  slot="options"
                                  @click="() => {gameStatusTeam_new_c.gst_missionsArrangementIndex_n = missionsArrangementIndex_n}"
                                  class="TQ_dropdown_option TQ_padding_8px"
                                  :key="missionsArrangementIndex_n"
                                  v-for="(missionsArrangements_c, missionsArrangementIndex_n) in p_questBody_c.qb_missionsArrangements_ac">
                                {{missionsArrangements_c.qbma_name_s}}
                            </div>
                        </tq-dropdown>
                    </div>
                </div>

            </div>

            <!-- update btn -->
            <tq-btn-approve
                    v-if="co_showUpdateBtn_b"
                    class="TQ_inline TQ_margin_8px"
                    btn-class="TQ_btn TQ_bg_gold TQ_borderRadius TQ_text_20px"
                    :system-lang-code="p_system_langCode_e"
                    :text="ass_strings.oneWord_update"
                    :popup-text="ass_strings.question_updateTeam"
                    :approve-cb="() => {m_userEvent_update() } ">
            </tq-btn-approve>
            <hr>

            <!-- used clues -->
            <div v-if="p_questBody_c.qb_metadata_c.qbm_quest_hiddenCodesMode_e > enum_supportClueCodeTypes.e_none_n && p_teamStatus_c">
                <div>
                    {{p_teamStatus_c.ts_usedClues_as}}
                </div>

                <hr>
            </div>

            <!-- players -->
            <div class="TQ_padding_8px ">
                <div class="TQ_text_bold" v-if="obj_empty_fb(gameStatusTeam_new_c.gst_players_byUserId_c)">
                    {{ass_strings.sentence_noPlayers[p_system_langCode_e]}}
                </div>

                <div v-else>
                    <table class="TQ_width_100p TQ_borderBox ">
                        <tr>
                            <th>#</th>
                            <th>{{ass_strings.oneWord_image[p_system_langCode_e]}}</th>
                            <th>{{ass_strings.oneWord_name[p_system_langCode_e]}}</th>
                            <th>{{ass_strings.oneWord_distance[p_system_langCode_e]}}</th>
                            <th>{{ass_strings.oneWord_battery[p_system_langCode_e]}}</th>
                            <th v-if="co_playerChoosePath_b">{{ass_strings.oneWord_path[p_system_langCode_e]}}</th>
                            <th>{{ass_strings.oneWord_actions[p_system_langCode_e]}}</th>
                        </tr>

                        <tr v-for="(player, playerId, index_n) in gameStatusTeam_new_c.gst_players_byUserId_c" v-if="p_playersData_byUserId_c[playerId]">

                            <td>{{index_n + 1}}</td>
                            <td >

                                <tq-avatar :p_ud_avatar_c="p_playersData_byUserId_c[playerId].ud_avatar_c"
                                           :key="$options.name + playerId"
                                           class="TQ_width_44px TQ_borderRadius"/>
                            </td>
                            <td >{{p_playersData_byUserId_c[playerId].ud_name_s}}</td>
                            <td >
                                <div v-if="p_playerMoreInfo_byUserId_c[playerId]">
                                    {{p_playerMoreInfo_byUserId_c[playerId].pmi_walkInMeters_n / 1000}}
                                </div>
                            </td>
                            <td class="TQ_padding_4px">

                                <tq-progress-bar
                                        class="TQ_text_12px TQ_textColor_white "
                                        v-if="p_playerMoreInfo_byUserId_c[playerId] && p_playerMoreInfo_byUserId_c[playerId].pmi_batteryLevel_n >= 0 "
                                        :p_progress_n="p_playerMoreInfo_byUserId_c[playerId].pmi_batteryLevel_n / 100"
                                        ps_line-height_s="16px"/>
                            </td>
                            <td class="TQ_padding_4px" v-if="co_playerChoosePath_b">
                                {{m_getSelectedPlayerChosenPath_s(playerId)}}
                            </td>
                            <td>

                                <tq-btn-approve
                                        class="TQ_inline"
                                        btn-class="TQ_bg_red TQ_borderRadius TQ_padding_4px TQ_box_shadow TQ_clickable"
                                        :system-lang-code="p_system_langCode_e"
                                        :text="ass_strings.oneWord_remove"
                                        :popup-text="ass_strings.question_removePlayer"
                                        :approve-cb="() => {m_removePlayer_f(playerId) } ">
                                </tq-btn-approve>

                                <!--<div class="TQ_btn TQ_bg_red TQ_borderRadius" @click="m_removePlayer_f(playerId)">-->
                                <!--{{ass_strings.oneWord_remove[p_system_langCode_e]}}-->
                                <!--</div>-->
                            </td>

                        </tr>

                    </table>
                </div>
            </div>


        </div>

        <hr>

        <!-- delete btn -->
        <div class="TQ_margin_bottom_4px">

            <!-- delete team -->
            <tq-btn-approve
                    class="TQ_inline TQ_margin_4px"
                    btn-class="TQ_btn TQ_bg_red TQ_borderRadius"
                    :system-lang-code="p_system_langCode_e"
                    :text="ass_strings.twoWords_deleteTeam"
                    :popup-text="ass_strings.question_deleteTeam"
                    :approve-cb="() => {m_deleteTeam_f() } ">
            </tq-btn-approve>


        </div>

    </div>

</template>

<script>
    import TqDropdown from "../../../../components/basic/TqDropdown";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb, validator_number_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {validator_objEmpty_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import TqImage from "../../../../components/basic/TqImage";
    import {
        ass_img_colors_w,
        ass_img_download_w,
        ass_img_user_b
    } from "../../../../assets/scripts/Ass_Files";
    import {
        enum_arrangeMissionsType_s,
        enum_cluesMode_e,
        enum_langCodes, enum_hiddenCodesTypes
    } from "../../../../../functions/src/shareCode/Share_S_Enum";
    import TqProgressBar from "../../../../components/basic2/TqProgressBar";
    import {obj_deepCopy_f, obj_equals_fb} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import TqBtnApprove from "../../../../components/basic2/TqBtnApprove";
    import {
        FB_GameStatus,
        FB_GameStatus_Team,
        FB_QuestBody,
        FB_QuestEvent, FB_TeamStatus
    } from "../../../../../functions/src/shareCode/Share_S_Classes";
    import TqEventStatusBar from "../../../../components/basic/TqEventStatusBar";
    import TqPickColor from "../../../../components/basic2/TqPickColor";
    import draggable from 'vuedraggable'
    import TqAvatar from "@/components/complex/TqAvatar";

    export default {
        name: "c_Creator_Events_Item_TeamStatus",
        components: {
            TqAvatar,
            TqPickColor, TqEventStatusBar, TqBtnApprove, TqProgressBar, TqImage, TqDropdown, draggable},
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_questEvent_c:{
                require: true,
                type: FB_QuestEvent
            },
            p_teamStatus_c:{
                require: true,
                type: FB_TeamStatus
            },
            p_gameStatus_c:{
                type: FB_GameStatus,
                require: true,
            },

            p_gameStatus_team_c:{
                require: true,
                type: FB_GameStatus_Team
            },
            p_questBody_c:{
                require: true,
                type: FB_QuestBody
            },

            p_playersData_byUserId_c:{
                require: true,
                default(){
                    return {}
                }
            },
            p_playerMoreInfo_byUserId_c:{
                type:Object,
                require: true
            },

            pe_gameStatusAndTeamStatus_update_f :{
                type: Function,
                require: true
            },
            pe_gameStatus_team_update_f:{
                type: Function,
                require: true
            },
            pe_gameStatus_team_delete_f:{
                type: Function,
                require: true
            },

        },
        data(){
            return {
                teamStatus_new_c    : null,
                gameStatusTeam_new_c: null,
                newMApAreasOrder_an  : [1,2,3],

                ass_strings         : ass_strings,
                ass_img_user_b      : ass_img_user_b,
                obj_empty_fb        : validator_objEmpty_fb,
                enum_cluesMode_e    : enum_cluesMode_e,
                ass_img_download_w    : ass_img_download_w,
                ass_img_colors_w    : ass_img_colors_w,
                enum_arrangeMissionsType_s    : enum_arrangeMissionsType_s,
                enum_supportClueCodeTypes    : enum_hiddenCodesTypes,

            }
        },
        computed:{
            co_showUpdateBtn_teamStatus_b(){
                return !obj_equals_fb(this.teamStatus_new_c, this.p_teamStatus_c)
            },
            co_showUpdateBtn_gameStatus_b(){
                return !obj_equals_fb(this.gameStatusTeam_new_c, this.p_gameStatus_team_c)
            },
            co_showUpdateBtn_b(){
                return this.co_showUpdateBtn_teamStatus_b || this.co_showUpdateBtn_gameStatus_b
            },
            co_playerChoosePath_b(){
                return this.p_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e === enum_arrangeMissionsType_s.player_choose_oneTime
            },
        },
        methods:{
            m_getSelectedPlayerChosenPath_s(playerId){

                if(!this.p_questBody_c || !this.p_gameStatus_c || !this.p_teamStatus_c
                    || this.p_gameStatus_c.gs_teams_byTeamId[this.p_teamStatus_c.ts_teamId_uid].gst_players_byUserId_c[playerId].gstp_pathIndex_n == null){
                    return "-"
                }


                return this.p_questBody_c.qb_missionsArrangements_ac[this.p_gameStatus_c.gs_teams_byTeamId[this.p_teamStatus_c.ts_teamId_uid].gst_players_byUserId_c[playerId].gstp_pathIndex_n].qbma_name_s
            },
            m_removePlayer_f(playerId){
                this.$delete(this.gameStatusTeam_new_c.gst_players_byUserId_c,playerId)
                this.$delete(this.p_gameStatus_team_c.gst_players_byUserId_c,playerId)

                this.pe_gameStatus_team_update_f(this.p_questEvent_c, this.gameStatusTeam_new_c.gst_teamId_uid, this.gameStatusTeam_new_c, () => {})
            },
            m_deleteTeam_f(playerId){
                this.$delete(this.gameStatusTeam_new_c.gst_players_byUserId_c,playerId)
                this.pe_gameStatus_team_delete_f(this.p_questEvent_c, this.gameStatusTeam_new_c.gst_teamId_uid, () => {})
            },
            m_userEvent_update(){

                // 1) update team status
                if(this.co_showUpdateBtn_teamStatus_b){
                    this.pe_gameStatusAndTeamStatus_update_f({
                        questEvent_c    : this.p_questEvent_c,
                        newTeamStatus_c : this.teamStatus_new_c,
                        oldTeamStatus_c : this.p_teamStatus_c,
                    })
                }

                // 2) update game status
                if(this.co_showUpdateBtn_gameStatus_b){
                    this.pe_gameStatus_team_update_f(this.p_questEvent_c, this.gameStatusTeam_new_c.gst_teamId_uid, this.gameStatusTeam_new_c, () => {})
                }

            },
            m_validateBonusPoint_f(){
                if(!validator_number_fb(this.teamStatus_new_c.ts_bonusPoints_n)){
                    this.teamStatus_new_c.ts_bonusPoints_n = 0
                }
            }
        },
        watch:{
            p_teamStatus_c:{
                handler(){
                    this.teamStatus_new_c = this.p_teamStatus_c != null ? new FB_TeamStatus(obj_deepCopy_f(this.p_teamStatus_c)) : null
                },
                deep: true,
                immediate: true
            },
            p_gameStatus_team_c:{
                handler(){

                    this.gameStatusTeam_new_c = this.p_gameStatus_team_c != null ? new FB_GameStatus_Team(obj_deepCopy_f(this.p_gameStatus_team_c)) : null
                },
                deep: true,
                immediate: true
            }
        }


    }
</script>

<style scoped lang="scss">

    .col{
        width:140px;
        display:inline-block;
        margin: 8px 16px 0px 0px;
    }





    table{
        background: white;
        border-collapse: collapse;
        /*display: inline-block;*/

        td, th{
            border: 2px solid black;
            padding: 4px;
        }

        td {
            text-transform: none;
        }

        th{
            background: gainsboro;
        }
    }

</style>
